const isLocalBrowser =
  typeof window !== "undefined" && ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const BASEAPIURL = isLocalBrowser
  ? "http://localhost:36001/"
  : "https://api.pairvio.com/";
